import { render } from "./NeurologicalDiseaseTreatmentPaths.vue?vue&type=template&id=0c3b4857&scoped=true"
import script from "./NeurologicalDiseaseTreatmentPaths.vue?vue&type=script&lang=js"
export * from "./NeurologicalDiseaseTreatmentPaths.vue?vue&type=script&lang=js"

import "./NeurologicalDiseaseTreatmentPaths.vue?vue&type=style&index=0&id=0c3b4857&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c3b4857"]])

export default __exports__